import React from "react";
import { Schema, JoeBehaviorGraphItem } from "../../../../../@types";
import { colors } from "../../../../../../relationship-graph/utils";
import SanitizeHTML from "../../../../../../../components/Sanitize";

export const behaviorGraph: Schema<JoeBehaviorGraphItem> = {
  fields: [
    {
      name: "name",
      displayTitle: "Name",
      sortable: true,
      component: d => <>{d.name}</>
    },
    {
      name: "pid",
      displayTitle: "PID",
      sortable: true,
      component: d => <>{d.pid}</>
    },
    {
      name: "parentpid",
      displayTitle: "Parent PID",
      sortable: true,
      component: d => <>{d.parentpid}</>
    },
    {
      name: "files",
      displayTitle: "Files",
      sortable: true,
      component: d => (
        <ul>
          {d.files?.map(file => (
            <li
              key={file.md5}
              style={{ color: file.malicious ? colors.malicious : "#000" }}
            >
              Path: {<SanitizeHTML html={file.path} />}
              <br />
              MD5: {<SanitizeHTML html={file.md5} />}
              <br />
              Filetype: {<SanitizeHTML html={file.filetype} />}
              <br />
            </li>
          ))}
        </ul>
      )
    }
  ]
};
